import React from 'react'
import { Box, Button, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { AuditResponse, CompanyProfile, Roles } from '@shared/types'
import { originalIcons } from '@shared/components/icons/icons'
import { useIsClientBasic } from '@shared/hooks/use-is-client-basic'
import { UnstyledLink } from '@shared/components/unstyled-link.component'
import { useRouter } from '@shared/hooks/use-router'
import { ACL } from '@shared/components/acl.component'

type Props = {
  companyProfile?: CompanyProfile
  audit?: AuditResponse
  isPreviewMode: boolean
}

const LABELS = {
  AUDIT: 'AUDYT',
  METRIC: 'Metryka',
  LEGAL_REQUIREMENTS: 'WYMAGANIA PRAWNE',
}

export const AuditHeaderTitle = (props: Props) => {
  const { companyProfile, audit, isPreviewMode } = props
  const { query } = useRouter<{
    companyID: number
    auditID: number
  }>()
  const { companyID, auditID } = query
  const classes = useStyles()
  const isClientBasic = useIsClientBasic()

  if (isClientBasic) {
    return (
      <Grid item>
        <Box
          display="flex"
          alignItems="center"
          className={classes.titleWrapper}
        >
          <Typography variant="h5" className={classes.title}>
            {isPreviewMode ? companyProfile?.name || audit?.companyName : ''}
          </Typography>
        </Box>
      </Grid>
    )
  }

  return (
    <Grid item>
      <Box display="flex" alignItems="start" className={classes.titleWrapper}>
        <Typography variant="h5" className={classes.title}>
          {companyProfile?.name || audit?.companyName}
        </Typography>
        {!props.isPreviewMode && (
          <ACL allowedRoles={[Roles.Admin, Roles.Auditor]}>
            <UnstyledLink to={`/audit-report/${companyID}/${auditID}`}>
              <Button variant="outlined" startIcon={<originalIcons.Paper />}>
                {LABELS.METRIC}
              </Button>
            </UnstyledLink>
          </ACL>
        )}
      </Box>
    </Grid>
  )
}

export const useStyles = makeStyles((theme) => {
  return {
    titleWrapper: {
      gap: theme.spacing(1),
      columnGap: 10,
      marginBottom: theme.spacing(1),
    },
    auditTitle: {
      color: theme.palette.text.disabled,
      backgroundColor: theme.palette.grey['100'],
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
      borderRadius: theme.spacing(1),
    },
    title: {
      textTransform: 'uppercase',
      fontWeight: 500,
    },
    number: {
      color: theme.palette.text.secondary,
    },
  }
})
